import React from 'react';

import Modal from 'components/shared/Modal';
import Button from 'components/shared/Button';

import type { PhotoUpload } from 'domains/photos';

type DeletePhotoModalProps = {
  photo: PhotoUpload;
  onConfirm: () => void;
  onCancel: () => void;
};

function DeletePhotoModal({ onConfirm, onCancel, photo }: DeletePhotoModalProps) {
  const buttons = (
    <React.Fragment>
      <Button type="confirm" onClick={onConfirm}>
        Confirm
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );
  return (
    <Modal
      title="Confirm Delete Photo"
      modalClass={['delete-photo-modal']}
      onClose={onCancel}
      primaryFooterGroup={buttons}
      labelledBy="confirm-delete-photo"
      lastFocusedElementId={`delete-collection-photo-${photo.id}`}
    >
      <p>Are you sure you would like to delete this photo? This cannot be undone.</p>
      <img src={photo.file_path_thumb} />
    </Modal>
  );
}

export default DeletePhotoModal;
